/**
 * 実行時設定値のシングル・ソース・オブ・トゥルース。
 * 環境変数の参照やフォールバック値を集約し、複数モジュールでドリフトしないようにする。
 */

/**
 * auth-relay の Cloud Functions ベース URL。
 * `VITE_FUNCTIONS_BASE_URL` が未設定の場合は dev の本番 URL をフォールバックとして使う。
 */
export const FUNCTIONS_BASE_URL =
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  "https://asia-northeast1-cmp-pjt-dev.cloudfunctions.net";
